// /*global kakao*/
import React, { useEffect } from 'react';

const JcoupMap = () => {

  useEffect(() => {
    // 1. kakao API가 로드되었는지 체크
    if (window.kakao && window.kakao.maps) {

      // 2. autoload=false 대응: API 로드가 끝난 후 지도 생성 logic 실행
      window.kakao.maps.load(() => {
        var container = document.getElementById('map1');

        var options = {
          center: new window.kakao.maps.LatLng(35.9019567, 128.5810435),
          level: 1
        };

        var map1 = new window.kakao.maps.Map(container, options);
        var markerPosition = new window.kakao.maps.LatLng(35.9019567, 128.5810435);

        var marker = new window.kakao.maps.Marker({
          position: markerPosition
        });

        marker.setMap(map1);
      });
    }
  }, []);

  return (
    <>
      <h3 style={{ textAlign: 'center', color: 'blue', backgroundColor: 'lightgray' }}>
        2공장:(주)제이콥 [Rubber접착(수지,캠록,FKM,몰리 등..)]
      </h3>
      <div>
        <div id="map1" style={{ width: "100%", height: "70vh" }}></div>
      </div>
      &nbsp;
      <h5 style={{ textAlign: 'center' }}>주소 : 대구시 북구 노원로동 39길6 (침산동)</h5>
    </>
  );
};

export default JcoupMap;